import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchCoupons(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/coupons', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchCoupon(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/coupon/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateCoupon(ctx, { id, couponData }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/coupon/${id}/update`, couponData)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteCoupon(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/coupon/${id}/delete`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}